import Loader from 'react-loader-spinner';
import styles from './Loading.module.css';

export default function Loading() {
  return (
    <div className={styles.loader}>
      <Loader type="Oval" color="var(--color--secondary)" />
    </div>
  );
}
